import * as React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

export default function LoadingCircle() {
  return (
    <Box sx={{ display: 'flex', width: '100%', height: '70vh', padding: '4% 0', justifyContent: 'center', alignItems: 'center'}}>
      <CircularProgress />
    </Box>
  );
}